/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface IAddressService {
        countryList: Array<IAddressListItem>;
        ncCountyList: Array<IAddressListItem>;
        stateList: Array<IAddressListItem>;
        validate: (addresses: Array<IAddress>) => ng.IPromise<Array<ValidationAddress>> ;
    }

    export interface IAddressListItem {
        label: string;
        value: string;
    }

    export class ValidationAddress implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    class VerifyAddressResults implements IVerifyAddressResultsViewModel {
        firstName: string;
        lastName: string;
        action: string;
        providedAddressHasErrors: boolean;
        key: string;
        providedAddress: ValidationAddress;
        suggestedAddress: ValidationAddress;

    }

    class AddressService implements IAddressService {
        static serviceId: string = "addressService";
        static $inject = ["Restangular", "$q", "$uibModal"];
        countryList: Array<IAddressListItem>;
        ncCountyList: Array<IAddressListItem>;
        stateList: Array<IAddressListItem>

        constructor(private Restangular: Restangular.IService, private $q: ng.IQService, private $uibModal) {
            this.countryList = this.getCountryList();
            this.stateList = this.getStateList();
            this.ncCountyList = this.getNCCountyList();
            
        }

        validate(addresses: Array<IAddress>): ng.IPromise<Array<ValidationAddress>> {
            var q = [];
            var addressErrorResults = new Array<VerifyAddressResults>();
            var results = new Array<ValidationAddress>();
            var defer = this.$q.defer <Array<ValidationAddress>>();

            addresses.forEach((address) => {
                q.push(this.validateAddress(address));
            });

            this.$q.all(q).then((responses) => {
                responses.forEach((response: VerifyAddressResults, index: number) => {
                    if (response !== null) {
                        response.key = addresses[index].key || index.toString();

                        if (response.providedAddressHasErrors) {
                            addressErrorResults.push(response);
                        }
                        else {
                            response.providedAddress.key = response.key;
                            results.push(response.providedAddress);
                        }
                    }
                });

                if (addressErrorResults.length > 0) {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/directives/cfncSelectAddress/cfncSelectAddressModal.html',
                        controller: 'cfncSelectAddressModal',
                        size: "lg",
                        keyboard: false,
                        backdrop: "static",
                        resolve: {
                            model: function () {
                                return addressErrorResults;
                            }
                        },
                    });

                    modalInstance.result.then((selectedAddress) => {
                        selectedAddress.forEach((selection) => {
                            results.push(selection);
                        });

                        defer.resolve(results);
                    }, (selectedAddress) => {
                        selectedAddress.forEach((selection) => {
                            results.push(selection);
                        });

                        defer.reject({ message: "User Cancelled", addresses: results });
                    });

                } else {

                    defer.resolve(results);
                }
            }, (reason) => {
                
            });

            return defer.promise;
        }

        private validateAddress(address: IAddress): ng.IPromise<any> {
            var defer = this.$q.defer();
            if (["US", "CA"].indexOf(address.country) > -1) {
                defer.promise = this.Restangular.all("Address").all("Validate").post(address)
            }
            else {
                defer.resolve(null);
            }

            return defer.promise;
        }

        private getCountryList(): Array<IAddressListItem> {
            return [{ label: "Afghanistan", value: "AF" },
            { label: "Albania", value: "AL" },
            { label: "Algeria", value: "DZ" },
            { label: "American Samoa", value: "AS" },
            { label: "Andorra", value: "AD" },
            { label: "Angola", value: "AO" },
            { label: "Anguilla", value: "AI" },
            { label: "Antarctica", value: "AQ" },
            { label: "Antigua and Barbuda", value: "AG" },
            { label: "Argentina", value: "AR" },
            { label: "Armenia", value: "AM" },
            { label: "Aruba", value: "AW" },
            { label: "Australia", value: "AU" },
            { label: "Austria", value: "AT" },
            { label: "Azerbaijan", value: "AZ" },
            { label: "Bahamas", value: "BS" },
            { label: "Bahrain", value: "BH" },
            { label: "Bangladesh", value: "BD" },
            { label: "Barbados", value: "BB" },
            { label: "Belarus", value: "BY" },
            { label: "Belgium", value: "BE" },
            { label: "Belize", value: "BZ" },
            { label: "Benin", value: "BJ" },
            { label: "Bermuda", value: "BM" },
            { label: "Bhutan", value: "BT" },
            { label: "Bolivia", value: "BO" },
            { label: "Bosnia and Herzegovina", value: "BA" },
            { label: "Botswana", value: "BW" },
            { label: "Bouvet Island", value: "BV" },
            { label: "Brazil", value: "BR" },
            { label: "British Indian Ocean Territory", value: "IO" },
            { label: "Brunei Darussalam", value: "BN" },
            { label: "Bulgaria", value: "BG" },
            { label: "Burkina Faso", value: "BF" },
            { label: "Burundi", value: "BI" },
            { label: "Cambodia", value: "KH" },
            { label: "Cameroon", value: "CM" },
            { label: "Canada", value: "CA" },
            { label: "Cape Verde", value: "CV" },
            { label: "Cayman Islands", value: "KY" },
            { label: "Central African Republic", value: "CF" },
            { label: "Chad", value: "TD" },
            { label: "Chile", value: "CL" },
            { label: "China", value: "CN" },
            { label: "Christmas Island", value: "CX" },
            { label: "Cocos (Keeling) Islands", value: "CC" },
            { label: "Colombia", value: "CO" },
            { label: "Comoros", value: "KM" },
            { label: "Congo", value: "CG" },
            { label: "Congo, The Democratic Republic of the", value: "CD" },
            { label: "Cook Islands", value: "CK" },
            { label: "Costa Rica", value: "CR" },
            { label: "Cote D'Ivoire", value: "CI" },
            { label: "Croatia", value: "HR" },
            { label: "Cuba", value: "CU" },
            { label: "Cyprus", value: "CY" },
            { label: "Czech Republic", value: "CZ" },
            { label: "Denmark", value: "DK" },
            { label: "Djibouti", value: "DJ" },
            { label: "Dominica", value: "DM" },
            { label: "Dominican Republic", value: "DO" },
            { label: "East Timor", value: "TP" },
            { label: "Ecuador", value: "EC" },
            { label: "Egypt", value: "EG" },
            { label: "El Salvador", value: "SV" },
            { label: "Equatorial Guinea", value: "GQ" },
            { label: "Eritrea", value: "ER" },
            { label: "Estonia", value: "EE" },
            { label: "Ethiopia", value: "ET" },
            { label: "Falkland Islands (Malvinas)", value: "FK" },
            { label: "Faroe Islands", value: "FO" },
            { label: "Fiji", value: "FJ" },
            { label: "Finland", value: "FI" },
            { label: "France", value: "FR" },
            { label: "French Guiana", value: "GF" },
            { label: "French Polynesia", value: "PF" },
            { label: "French Southern Territories", value: "TF" },
            { label: "Gabon", value: "GA" },
            { label: "Gambia", value: "GM" },
            { label: "Georgia", value: "GE" },
            { label: "Germany", value: "DE" },
            { label: "Ghana", value: "GH" },
            { label: "Gibraltar", value: "GI" },
            { label: "Greece", value: "GR" },
            { label: "Greenland", value: "GL" },
            { label: "Grenada", value: "GD" },
            { label: "Guadeloupe", value: "GP" },
            { label: "Guam", value: "GU" },
            { label: "Guatemala", value: "GT" },
            { label: "Guinea", value: "GN" },
            { label: "Guinea-Bissau", value: "GW" },
            { label: "Guyana", value: "GY" },
            { label: "Haiti", value: "HT" },
            { label: "Heard Island and Mcdonald Islands", value: "HM" },
            { label: "Holy See (Vatican City State)", value: "VA" },
            { label: "Honduras", value: "HN" },
            { label: "Hong Kong", value: "HK" },
            { label: "Hungary", value: "HU" },
            { label: "Iceland", value: "IS" },
            { label: "India", value: "IN" },
            { label: "Indonesia", value: "ID" },
            { label: "Iran, Islamic Republic of", value: "IR" },
            { label: "Iraq", value: "IQ" },
            { label: "Ireland", value: "IE" },
            { label: "Israel", value: "IL" },
            { label: "Italy", value: "IT" },
            { label: "Jamaica", value: "JM" },
            { label: "Japan", value: "JP" },
            { label: "Jordan", value: "JO" },
            { label: "Kazakstan", value: "KZ" },
            { label: "Kenya", value: "KE" },
            { label: "Kiribati", value: "KI" },
            { label: "Korea, Democratic People's Republic of", value: "KP" },
            { label: "Korea, Republic of", value: "KR" },
            { label: "Kuwait", value: "KW" },
            { label: "Kyrgyzstan", value: "KG" },
            { label: "Lao People's Democratic Republic", value: "LA" },
            { label: "Latvia", value: "LV" },
            { label: "Lebanon", value: "LB" },
            { label: "Lesotho", value: "LS" },
            { label: "Liberia", value: "LR" },
            { label: "Libyan Arab Jamahiriya", value: "LY" },
            { label: "Liechtenstein", value: "LI" },
            { label: "Lithuania", value: "LT" },
            { label: "Luxembourg", value: "LU" },
            { label: "Macau", value: "MO" },
            { label: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
            { label: "Madagascar", value: "MG" },
            { label: "Malawi", value: "MW" },
            { label: "Malaysia", value: "MY" },
            { label: "Maldives", value: "MV" },
            { label: "Mali", value: "ML" },
            { label: "Malta", value: "MT" },
            { label: "Marshall Islands", value: "MH" },
            { label: "Martinique", value: "MQ" },
            { label: "Mauritania", value: "MR" },
            { label: "Mauritius", value: "MU" },
            { label: "Mayotte", value: "YT" },
            { label: "Mexico", value: "MX" },
            { label: "Micronesia, Federated States of", value: "FM" },
            { label: "Moldova, Republic of", value: "MD" },
            { label: "Monaco", value: "MC" },
            { label: "Mongolia", value: "MN" },
            { label: "Montserrat", value: "MS" },
            { label: "Morocco", value: "MA" },
            { label: "Mozambique", value: "MZ" },
            { label: "Myanmar", value: "MM" },
            { label: "Namibia", value: "NA" },
            { label: "Nauru", value: "NR" },
            { label: "Nepal", value: "NP" },
            { label: "Netherlands", value: "NL" },
            { label: "Netherlands Antilles", value: "AN" },
            { label: "New Caledonia", value: "NC" },
            { label: "New Zealand", value: "NZ" },
            { label: "Nicaragua", value: "NI" },
            { label: "Niger", value: "NE" },
            { label: "Nigeria", value: "NG" },
            { label: "Niue", value: "NU" },
            { label: "Norfolk Island", value: "NF" },
            { label: "Northern Mariana Islands", value: "MP" },
            { label: "Norway", value: "NO" },
            { label: "Oman", value: "OM" },
            { label: "Pakistan", value: "PK" },
            { label: "Palau", value: "PW" },
            { label: "Palestinian Territory, Occupied", value: "PS" },
            { label: "Panama", value: "PA" },
            { label: "Papua New Guinea", value: "PG" },
            { label: "Paraguay", value: "PY" },
            { label: "Peru", value: "PE" },
            { label: "Philippines", value: "PH" },
            { label: "Pitcairn", value: "PN" },
            { label: "Poland", value: "PL" },
            { label: "Portugal", value: "PT" },
            { label: "Puerto Rico", value: "PR" },
            { label: "Qatar", value: "QA" },
            { label: "Reunion", value: "RE" },
            { label: "Romania", value: "RO" },
            { label: "Russian Federation", value: "RU" },
            { label: "Rwanda", value: "RW" },
            { label: "Saint Helena", value: "SH" },
            { label: "Saint Kitts and Nevis", value: "KN" },
            { label: "Saint Lucia", value: "LC" },
            { label: "Saint Pierre and Miquelon", value: "PM" },
            { label: "Saint Vincent and the Grenadines", value: "VC" },
            { label: "Samoa", value: "WS" },
            { label: "San Marino", value: "SM" },
            { label: "Sao Tome and Principe", value: "ST" },
            { label: "Saudi Arabia", value: "SA" },
            { label: "Senegal", value: "SN" },
            { label: "Serbia and Montenegro", value: "CS" },
            { label: "Seychelles", value: "SC" },
            { label: "Sierra Leone", value: "SL" },
            { label: "Singapore", value: "SG" },
            { label: "Slovakia", value: "SK" },
            { label: "Slovenia", value: "SI" },
            { label: "Solomon Islands", value: "SB" },
            { label: "Somalia", value: "SO" },
            { label: "South Africa", value: "ZA" },
            { label: "South Georgia and the South Sandwich Islands", value: "GS" },
            { label: "Spain", value: "ES" },
            { label: "Sri Lanka", value: "LK" },
            { label: "Sudan", value: "SD" },
            { label: "Suriname", value: "SR" },
            { label: "Svalbard and Jan Mayen", value: "SJ" },
            { label: "Swaziland", value: "SZ" },
            { label: "Sweden", value: "SE" },
            { label: "Switzerland", value: "CH" },
            { label: "Syrian Arab Republic", value: "SY" },
            { label: "Taiwan", value: "TW" },
            { label: "Tajikistan", value: "TJ" },
            { label: "Tanzania, United Republic of", value: "TZ" },
            { label: "Thailand", value: "TH" },
            { label: "Togo", value: "TG" },
            { label: "Tokelau", value: "TK" },
            { label: "Tonga", value: "TO" },
            { label: "Trinidad and Tobago", value: "TT" },
            { label: "Tunisia", value: "TN" },
            { label: "Turkey", value: "TR" },
            { label: "Turkmenistan", value: "TM" },
            { label: "Turks and Caicos Islands", value: "TC" },
            { label: "Tuvalu", value: "TV" },
            { label: "Uganda", value: "UG" },
            { label: "Ukraine", value: "UA" },
            { label: "United Arab Emirates", value: "AE" },
            { label: "United Kingdom", value: "GB" },
            { label: "United States", value: "US" },
            { label: "United States Minor Outlying Islands", value: "UM" },
            { label: "Uruguay", value: "UY" },
            { label: "Uzbekistan", value: "UZ" },
            { label: "Vanuatu", value: "VU" },
            { label: "Venezuela", value: "VE" },
            { label: "Viet Nam", value: "VN" },
            { label: "Virgin Islands, British", value: "VG" },
            { label: "Virgin Islands, U.S.", value: "VI" },
            { label: "Wallis and Futuna", value: "WF" },
            { label: "Western Sahara", value: "EH" },
            { label: "Yemen", value: "YE" },
            { label: "Yugoslavia", value: "YU" },
            { label: "Zambia", value: "ZM" },
            { label: "Zimbabwe", value: "ZW" }];
        }

        private getStateList(): Array<IAddressListItem> {
            return [{ value: "AL", label: "Alabama" },
            { value: "AK", label: "Alaska" },
            { value: "AS", label: "American Samoa" },
            { value: "AZ", label: "Arizona" },
            { value: "AR", label: "Arkansas" },
            { value: "AA", label: "Armed Forces Americas (AA)" },
            { value: "AP", label: "Armed Forces Pacific (AP)" },
            { value: "AE", label: "Armed Forces Other (AE)" },
            { value: "CA", label: "California" },
            { value: "CO", label: "Colorado" },
            { value: "CT", label: "Connecticut" },
            { value: "DE", label: "Delaware" },
            { value: "DC", label: "District of Columbia" },
            { value: "FM", label: "Federated States of Micronesia" },
            { value: "FL", label: "Florida" },
            { value: "GA", label: "Georgia" },
            { value: "GU", label: "Guam" },
            { value: "HI", label: "Hawaii" },
            { value: "ID", label: "Idaho" },
            { value: "IL", label: "Illinois" },
            { value: "IN", label: "Indiana" },
            { value: "IA", label: "Iowa" },
            { value: "KS", label: "Kansas" },
            { value: "KY", label: "Kentucky" },
            { value: "LA", label: "Louisiana" },
            { value: "ME", label: "Maine" },
            { value: "MH", label: "Marshall Islands" },
            { value: "MD", label: "Maryland" },
            { value: "MA", label: "Massachusetts" },
            { value: "MI", label: "Michigan" },
            { value: "MN", label: "Minnesota" },
            { value: "MS", label: "Mississippi" },
            { value: "MO", label: "Missouri" },
            { value: "MT", label: "Montana" },
            { value: "NE", label: "Nebraska" },
            { value: "NV", label: "Nevada" },
            { value: "NH", label: "New Hampshire" },
            { value: "NJ", label: "New Jersey" },
            { value: "NM", label: "New Mexico" },
            { value: "NY", label: "New York" },
            { value: "NC", label: "North Carolina" },
            { value: "ND", label: "North Dakota" },
            { value: "MP", label: "Northern Mariana Islands" },
            { value: "OH", label: "Ohio" },
            { value: "OK", label: "Oklahoma" },
            { value: "OR", label: "Oregon" },
            { value: "PA", label: "Pennsylvania" },
            { value: "PR", label: "Puerto Rico" },
            { value: "PW", label: "Palau" },
            { value: "RI", label: "Rhode Island" },
            { value: "SC", label: "South Carolina" },
            { value: "SD", label: "South Dakota" },
            { value: "TN", label: "Tennessee" },
            { value: "TX", label: "Texas" },
            { value: "UT", label: "Utah" },
            { value: "VT", label: "Vermont" },
            { value: "VI", label: "Virgin Islands" },
            { value: "VA", label: "Virginia" },
            { value: "WA", label: "Washington" },
            { value: "WV", label: "West Virginia" },
            { value: "WI", label: "Wisconsin" },
            { value: "WY", label: "Wyoming" }];
        }

        private getNCCountyList(): Array<IAddressListItem> {
            return [{ label: "Alamance", value: "001" },
            { label: "Alexander", value: "002" },
            { label: "Alleghany", value: "003" },
            { label: "Anson", value: "004" },
            { label: "Ashe", value: "005" },
            { label: "Avery", value: "006" },
            { label: "Beaufort", value: "007" },
            { label: "Bertie", value: "008" },
            { label: "Bladen", value: "009" },
            { label: "Brunswick", value: "010" },
            { label: "Buncombe", value: "011" },
            { label: "Burke", value: "012" },
            { label: "Cabarrus", value: "013" },
            { label: "Caldwell", value: "014" },
            { label: "Camden", value: "015" },
            { label: "Carteret", value: "016" },
            { label: "Caswell", value: "017" },
            { label: "Catawba", value: "018" },
            { label: "Chatham", value: "019" },
            { label: "Cherokee", value: "020" },
            { label: "Chowan", value: "021" },
            { label: "Clay", value: "022" },
            { label: "Cleveland", value: "023" },
            { label: "Columbus", value: "024" },
            { label: "Craven", value: "025" },
            { label: "Cumberland", value: "026" },
            { label: "Currituck", value: "027" },
            { label: "Dare", value: "028" },
            { label: "Davidson", value: "029" },
            { label: "Davie", value: "030" },
            { label: "Duplin", value: "031" },
            { label: "Durham", value: "032" },
            { label: "Edgecombe", value: "033" },
            { label: "Forsyth", value: "034" },
            { label: "Franklin", value: "035" },
            { label: "Gaston", value: "036" },
            { label: "Gates", value: "037" },
            { label: "Graham", value: "038" },
            { label: "Granville", value: "039" },
            { label: "Greene", value: "040" },
            { label: "Guilford", value: "041" },
            { label: "Halifax", value: "042" },
            { label: "Harnett", value: "043" },
            { label: "Haywood", value: "044" },
            { label: "Henderson", value: "045" },
            { label: "Hertford", value: "046" },
            { label: "Hoke", value: "047" },
            { label: "Hyde", value: "048" },
            { label: "Iredell", value: "049" },
            { label: "Jackson", value: "050" },
            { label: "Johnston", value: "051" },
            { label: "Jones", value: "052" },
            { label: "Lee", value: "053" },
            { label: "Lenoir", value: "054" },
            { label: "Lincoln", value: "055" },
            { label: "Macon", value: "056" },
            { label: "Madison", value: "057" },
            { label: "Martin", value: "058" },
            { label: "McDowell", value: "059" },
            { label: "Mecklenburg", value: "060" },
            { label: "Mitchell", value: "061" },
            { label: "Montgomery", value: "062" },
            { label: "Moore", value: "063" },
            { label: "Nash", value: "064" },
            { label: "New Hanover", value: "065" },
            { label: "Northampton", value: "066" },
            { label: "Onslow", value: "067" },
            { label: "Orange", value: "068" },
            { label: "Pamlico", value: "069" },
            { label: "Pasquotank", value: "070" },
            { label: "Pender", value: "071" },
            { label: "Perquimans", value: "072" },
            { label: "Person", value: "073" },
            { label: "Pitt", value: "074" },
            { label: "Polk", value: "075" },
            { label: "Randolph", value: "076" },
            { label: "Richmond", value: "077" },
            { label: "Robeson", value: "078" },
            { label: "Rockingham", value: "079" },
            { label: "Rowan", value: "080" },
            { label: "Rutherford", value: "081" },
            { label: "Sampson", value: "082" },
            { label: "Scotland", value: "083" },
            { label: "Stanly", value: "084" },
            { label: "Stokes", value: "085" },
            { label: "Surry", value: "086" },
            { label: "Swain", value: "087" },
            { label: "Transylvania", value: "088" },
            { label: "Tyrrell", value: "089" },
            { label: "Union", value: "090" },
            { label: "Vance", value: "091" },
            { label: "Wake", value: "092" },
            { label: "Warren", value: "093" },
            { label: "Washington", value: "094" },
            { label: "Watauga", value: "095" },
            { label: "Wayne", value: "096" },
            { label: "Wilkes", value: "097" },
            { label: "Wilson", value: "098" },
            { label: "Yadkin", value: "099" },
            { label: "Yancey", value: "100" }];
        }

    }

    angular.module("app").service(AddressService.serviceId, AddressService);
}